export default {
  fromLoggedUser: 1,
  fromNewUser: 2,
  fromApliUser: 3,
  fromSearchAssociatesUser: 4
};


// WEBPACK FOOTER //
// ./src/constants/application-flow-types.js